import { Link } from 'react-router-dom';

export function NavBar() {
  return (
    <nav className="bg-surface border-b border-gray-700 px-4 py-3 flex gap-6 text-sm">
      <Link to="/" className="text-white font-semibold hover:text-secondary transition-colors">
        Skill Scout
      </Link>
      <Link to="/registry" className="text-gray-300 hover:text-white transition-colors">
        Registry
      </Link>
      <Link to="/digest" className="text-gray-300 hover:text-white transition-colors">
        Digests
      </Link>
      <Link to="/add-tool" className="ml-auto text-gray-300 hover:text-white transition-colors">
        + Add Tool
      </Link>
    </nav>
  );
}
